import register from '@kpsys/angularjs-register';
import './kp-barcode-scanner.less' // global scanner styles
import {BarcodeScannerService} from './barcode-scanner.service';
import {KpBarcodeScannerDirective} from './kp-barcode-scanner.directive';
import {KpBarcodeScannerViewerComponent} from './kp-barcode-scanner-viewer/kp-barcode-scanner-viewer.component';
import {KpBarcodeScannerInputControlComponent} from './kp-barcode-scanner-input-control/kp-barcode-scanner-input-control.component';
import {zxingJsBarcodeScannerFactory} from './zxing-js-barcode-scanner/zxing-js-barcode-scanner.factory';
import type {ScannerSettings} from './barcode-scanner.types';
import {BarcodeFormat} from './barcode-scanner.types';
import {isCameraSupported} from './utils';


const defaultScannerSettings: ScannerSettings = {
    allowEmptyResult: false,
    codeFormats: [BarcodeFormat.EAN_13, BarcodeFormat.EAN_8, BarcodeFormat.CODE_39, BarcodeFormat.CODE_128],
    scanHeight: 360,
    scanWidth: 480,
    timeBetweenDecodeInMillis: 500,
    timeBetweenScansInMillis: 500,
    tryHarder: false
}

const module = register('portaro.barcode-scanner')
    .constant('DEFAULT_SCANNER_SETTINGS', defaultScannerSettings)
    .service(BarcodeScannerService.serviceName, BarcodeScannerService)
    .factory(zxingJsBarcodeScannerFactory.factoryName, zxingJsBarcodeScannerFactory);

// if camera API is not supported, do not register directives and components (rather than do check in every component individually)
if (isCameraSupported()) {
    module
        .directive(KpBarcodeScannerDirective.directiveName, KpBarcodeScannerDirective)
        .component(KpBarcodeScannerViewerComponent.componentName, KpBarcodeScannerViewerComponent)
        .component(KpBarcodeScannerInputControlComponent.componentName, KpBarcodeScannerInputControlComponent)
}

export default module.name();
